import { Dialog } from "@sportsmet/ui";
import type { ReactNode } from "react";

export type typeActionMenuRow = {
  key: string;
  label: string;
  isDestructive?: boolean;
  onSelect: () => void;
};

export type typeMessageActionDialogProps = {
  open: boolean;
  rows: typeActionMenuRow[];
  onOpenChange: (open: boolean) => void;
};

export const MessageActionDialog = (
  props: typeMessageActionDialogProps,
): ReactNode => {
  return (
    <Dialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      title="Message"
      autoFocus={false}
    >
      <div className="flex flex-col">
        {props.rows.map((row) => (
          <button
            key={row.key}
            type="button"
            onClick={() => {
              row.onSelect();
              props.onOpenChange(false);
            }}
            className={`flex min-h-touch-target w-full items-center px-4 text-left text-body ${
              row.isDestructive ? "text-error" : ""
            }`}
          >
            {row.label}
          </button>
        ))}
      </div>
    </Dialog>
  );
};
